import * as s from "@gromia/components/theme/t.module.css";
import { Button, LinkButton } from "@gromia/components/ui/Button";
import cx from "classnames";
import { pipe } from "fp-ts/lib/function";
import * as O from "fp-ts/lib/Option";
import * as R from "fp-ts/lib/Record";
import { Link } from "gatsby";
import React from "react";

type Props = {
  title1: NonNullable<React.ReactNode>;
  title2: NonNullable<React.ReactNode>;
  smallerTitle?: boolean;
  layout?: "50" | "60" | "75";
};

export function Trustpilot() {}

type HeroLandingContentProps = Props & {
  cta: NonNullable<React.ReactNode>;
  ctaHref: string;
  ctaOnClick?: () => void;
  cta2?: NonNullable<React.ReactNode>;
  cta2Href?: string;
};

type HeroLandingContentPropsSimple = Props & {
  cta: NonNullable<React.ReactNode>;
};

export function HeroLandingContentSimple(props: HeroLandingContentPropsSimple) {
  return <HeroLandingContentBase {...props}>{props.cta}
  </HeroLandingContentBase>;
}

export function HeroLandingContent(props: HeroLandingContentProps) {
  return (
    <HeroLandingContentBase {...props}>
      {props.ctaOnClick
        ? (
          <Button color="btnCta" size="btnXl" onClick={props.ctaOnClick}>
            {props.cta}
          </Button>
        )
        : (
          <LinkButton color="btnCta" to={props.ctaHref}>
            {props.cta}
          </LinkButton>
        )}
      {props.cta2 && props.cta2Href
        ? (
          <div>
            <div className={cx(s.fontSizeBig, s.my4)}>oppure</div>
            <Link
              to={props.cta2Href}
              className={cx(
                s.fontSizeBig,
                s.fontWeightSemiBold,
                s.textWhite,
                s.textDecorationUnderline,
              )}
            >
              {props.cta2}
            </Link>
          </div>
        )
        : null}
    </HeroLandingContentBase>
  );
}

export function HeroLandingContentBase(
  props: Props & {
    children?: React.ReactNode;
  },
) {
  const wClassMap = {
    50: s.wLg50,
    60: s.wLg60,
    75: s.wLg75,
  };

  const lgWClass = pipe(
    props.layout,
    O.fromNullable,
    O.chain(key => pipe(wClassMap, R.lookup(key))),
    O.getOrElse(() => wClassMap[50]),
  );

  return (
    <div className={cx(lgWClass, s.mt11, s.mb7)}>
      <h1
        style={props.smallerTitle ? { fontSize: "2.875rem" } : {}}
        className={cx(
          s.fontSizeLgHuge3,
          s.fontSizeMdHuge2,
          s.fontSizeHuge1,
          s.fontWeightBold,
          s.textShadow,
          s.mb4,
        )}
      >
        {props.title1}
      </h1>
      <h2
        className={cx(
          s.fontSizeLgLarge2,
          s.fontSizeMdBig,
          s.fontSizeBase,
          s.fontWeightNormal,
          s.textShadow,
          s.mb5,
        )}
      >
        {props.title2}
      </h2>
      {props.children}
    </div>
  );
}
